module.exports = __webpack_public_path__ + "img/2.de5640f2.jpg";